import React, { Component } from 'react';
//import { simpleRestClient } from 'admin-on-rest';
import { connect } from 'react-redux';
import { Button } from 'react-admin';
import { contributionApprove as contributionApproveAction } from './contributionActions';
import MasterContributionIcons from './MasterContributionIcons';

import DoneIcon from '@material-ui/icons/Done';
import PendingIcon from '@material-ui/icons/TouchApp';
import UnknownIcon from '@material-ui/icons/Update';
import RejectedIcon from '@material-ui/icons/Clear';

class ApproveButton extends Component {
  handleClick = (record, missionId) => {
    this.props.contributionApproveAction(record, missionId);
  };

  render() {
    let {
      contributionId,
      label,
      missionId,
      record,
      roleLevel,
      translate,
      ...rest
    } = this.props;

    if (record.id && roleLevel >= 2) {
      return (
        <MasterContributionIcons
          record={record}
          missionId={missionId ? missionId : record.missionId}
          translate={translate}
        />
      );
    } else if (record.id && record.state === 'approved') {
      return (
        <DoneIcon
          style={{
            color: 'green',
            border: '2px solid green',
            borderRadius: '50%',
            padding: 5,
            boxShadow: '1px 1px 5px grey',
            marginLeft: 10
          }}
        />
      );
    } else if (record.id && record.state === 'pending_review') {
      return roleLevel > 0 ? (
        <Button
          //label={label}
          {...rest}
          onClick={event => {
            this.handleClick(record, missionId ? missionId : record.missionId);
          }}
          style={{ marginRight: 0 }}
        >
          <PendingIcon
            style={{
              color: 'orange',
              border: '2px solid orange',
              borderRadius: '30%',
              padding: 5,
              boxShadow: '2px 2px 5px grey'
            }}
          />
        </Button>
      ) : (
        <PendingIcon
          style={{
            color: 'orange',
            border: '2px solid orange',
            borderRadius: '30%',
            padding: 5,
            marginLeft: 10,
            boxShadow: '2px 2px 5px grey'
          }}
        />
      );
    } else if (!record.end) {
      return (
        <UnknownIcon
          style={{
            color: 'grey',
            border: '2px solid grey',
            borderRadius: '30%',
            padding: 5,
            boxShadow: '2px 2px 5px grey',
            marginLeft: 10
          }}
        />
      );
    } else {
      return (
        <RejectedIcon
          style={{
            color: 'red',
            border: '2px solid red',
            borderRadius: '30%',
            padding: 5,
            boxShadow: '2px 2px 5px grey',
            marginLeft: 10
          }}
        />
      );
    }
  }
}

// const mapStateToProps = state => {
//   // console.log('mapStateToProps', state);
//   // const newState = state;
//   // return newState;
//   const { contributionId } = state;
//   return { contributionId };
// };

export default connect(
  null,
  { contributionApproveAction }
)(ApproveButton);



// WEBPACK FOOTER //
// ./src/contributions/ApproveButton.js